import { render, staticRenderFns } from "./beneficiary-collection.vue?vue&type=template&id=5d4160de&"
import script from "./beneficiary-collection.vue?vue&type=script&lang=js&"
export * from "./beneficiary-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports